<template>
    <div>
        <form class="forms-sample" method="POST">
            <input type="hidden" name="_token" :value="csrf">
            <input type="hidden" name="tab" value="user_configuration">
            <div class="row mb-9 my-3">
                <div class="col-sm-6">
                    <div class="form-check">
                        <input class="form-check-input" name="is_allow_config_page" type="checkbox" :value="is_allow_config_page" v-model="is_allow_config_page" id="cb_is_open_section">
                        <label class="form-check-label" for="cb_is_open_section">{{ translate.label }} <a href="https://freevpnplanet.com">https://freevpnplanet.com</a></label>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="input-group">
                        <div class="col-sm-9">
                            <button class="btn btn-primary me-2">{{ translate.save }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <hr/>

        <form id="form-configurations" class="forms-sample">
            <div class="row mb-9 my-3">
                <label class="col-sm-4 col-form-label">{{ translate.country }}</label>
                <div class="col-sm-6">
                    <select class="form-select" name="nodes_pool_id" v-model="nodes_pool_id" @change="clean()">
                        <option v-for="item in locations" :value="item.id">{{ item.title }}</option>
                    </select>
                </div>
            </div>

            <div class="row mb-9 my-3">
                <label class="col-sm-4 col-form-label">{{ translate.protocol }}</label>
                <div class="col-sm-6">
                    <select class="form-select" name="protocol" v-model="protocol" @change="clean()">
                        <option v-for="(title, key) in protocols" :value="key">{{ title }}</option>
                    </select>
                </div>
            </div>

            <div class="row mb-9 my-3" v-if="['tcp_xor', 'udp_xor'].includes(protocol)">
                <div class="col-sm-4"></div>
                <div class="col-sm-6">
                    <div class="form-check">
                        <input class="form-check-input" name="is_ru_configuration" type="checkbox" v-model="is_ru_configuration" id="cb_is_ru" @change="clean()">
                        <label class="form-check-label" for="cb_is_ru">{{ translate.ru_configuration }}</label>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-9 my-3">
                    <button class="btn btn-primary me-2" :disabled="isDisabled" @click.prevent="getConfiguration()">{{ translate.get }}</button>
                </div>
            </div>

            <div class="row" v-if="showEmptyMessage">
                <hr/>
                <div>{{ translate.not_result }}</div>
            </div>

            <!-- ovpn block -->
            <div class="row mb-9 my-3" style="display: block;" v-model="ovpnData" v-if="isOvpnPresent">
                <hr/>
                <div class="col-mb-9">
                    <div v-for="(conf, id) in ovpnData" class="btn btn-light me-2"
                         @click.prevent="downloadFile(id)">{{ locationTitle }} - {{ id }}
                    </div>
                </div>
            </div>

            <!-- other protocols block -->
            <div style="display: block;" v-model="protocolData" v-if="isProtocolPresent">
                <hr/>
                <div class="row mb-9 my-3"><label class="col-sm-4 col-form-label">User id</label>
                    <div class="col-sm-6 ">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <button type="button" class="btn btn-outline-secondary btn-copy" @click="copyInputText">copy</button>
                            </div>
                            <input type="text" readonly aria-describedby="basic-addon1" class="form-control" :value="protocolUser">
                        </div>
                    </div>
                </div>

                <div class="row mb-9 my-3"><label class="col-sm-4 col-form-label">Password</label>
                    <div class="col-sm-6 ">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <button type="button" class="btn btn-outline-secondary btn-copy" @click="copyInputText">copy</button>
                            </div>
                            <input type="text" readonly aria-describedby="basic-addon1" class="form-control" :value="protocolAccessKey">
                        </div>
                    </div>
                </div>

                <div v-for="(conf, id) in protocolData">
                    <hr/>
                    <div class="row mb-9 my-3"><label class="col-sm-4 col-form-label">IP</label>
                        <div class="col-sm-6 ">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <button type="button" class="btn btn-outline-secondary btn-copy" @click="copyInputText">copy</button>
                                </div>
                                <input type="text" readonly aria-describedby="basic-addon1" class="form-control" :value="conf.ip_address">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-9 my-3"><label class="col-sm-4 col-form-label">Hostname</label>
                        <div class="col-sm-6 ">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <button type="button" class="btn btn-outline-secondary btn-copy" @click="copyInputText">copy</button>
                                </div>
                                <input type="text" readonly aria-describedby="basic-addon1" class="form-control" :value="conf.host">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: ['lists', 'userId', 'configUrl', 'user', 'csrf', 'translate'],
    data() {
        return {
            locations: [],
            protocols: this.lists.protocols,
            nodes_pool_id: 0,
            protocol: '',
            is_ru_configuration: 0,
            ovpnData: [],
            protocolData: [],
            showEmptyMessage: false,
            is_allow_config_page: this.user.is_allow_config_page,
        }
    },
    computed: {
        isDisabled: function() {
            return this.nodes_pool_id < 1 || this.protocol === '';
        },
        isOvpnPresent: function () {
            return Object.keys(this.ovpnData).length > 0;
        },
        isProtocolPresent: function () {
            return Object.keys(this.protocolData).length > 0;
        },
        locationTitle: function () {
            let self = this,
                location = this.locations.filter(function (loc) { return loc.id === self.nodes_pool_id })[0];

            return location ? location.title : '';
        },
        protocolAccessKey: function () {
            return Object.values(this.protocolData)[0].access_key;
        },
        protocolUser: function () {
            return Object.values(this.protocolData)[0].access_user;
        },
    },
    methods: {
        getConfiguration() {
            let self = this,
                protocol = this.protocol,
                is_xor = false;

            this.clean();

            if (['tcp_xor', 'udp_xor'].includes(this.protocol)) {
                is_xor = true;
                protocol = this.protocol.replace("_xor", "");
            }

            axios.post(this.configUrl, {
                'nodes_pool_id': this.nodes_pool_id,
                'protocol': protocol,
                'is_ru_configuration': this.is_ru_configuration,
                'is_xor': is_xor,
            }).then(function (response) {
                if (response.data && response.data.success === true) {
                    response = response.data;

                    if (Object.keys(response.data).length) {
                        if (response.is_ovpn === true) {
                            self.ovpnData = response.data;
                        } else {
                            self.protocolData = response.data;
                        }
                    } else {
                        self.showEmptyMessage = true;
                    }
                } else {
                    self.showEmptyMessage = true;
                }
            });
        },
        downloadFile(id) {
            let fileName = this.locationTitle + '-' + id + '-' + this.protocol +'.ovpn',
                file = new File(["\ufeff" + this.ovpnData[id]], fileName, {type: "text/plain:charset=UTF-8"}),
                url = window.URL.createObjectURL(file);

            let a = document.createElement("a");
            a.style = "display: none";
            a.href = url;
            a.download = file.name;
            a.click();
            window.URL.revokeObjectURL(url);
        },
        clean() {
            this.ovpnData = [];
            this.protocolData = [];
            this.showEmptyMessage = false;
        },
        copyInputText(event) {
            const inputContent = event.currentTarget.parentElement.nextElementSibling.value;
            let buttonText = event.currentTarget,
                allButtonsText = document.querySelectorAll('#form-configurations .btn-copy'),
                copyTextInterval;

            for (let i = 0; i < allButtonsText.length; i++) {
                allButtonsText[i].innerText = 'copy';
            }

            if (inputContent) {
                clearTimeout(copyTextInterval);
                navigator.clipboard.writeText(inputContent).then(() => {
                    buttonText.innerText = 'copied';
                    copyTextInterval = setTimeout(() => {
                        buttonText.innerText = 'copy';
                    }, 3000);
                })
            }
        }
    },
    mounted() {
        let self = this;
        axios
            .get('/ajax/list/locations')
            .then(function (response) {
                self.locations = response.data;
            });
    }
}
</script>
<style>
    #form-configurations input[readonly]{
        background-color:transparent;
    }
</style>
